import React from "react";
import "./styles/MetricCard.css";

/**
 * MetricCard - Displays a metric with icon, title, and value
 * @param {Object} props
 * @param {React.ReactNode} props.icon - Icon component
 * @param {string} props.title - Card title
 * @param {string|number} props.value - Main value
 * @param {string} props.tone - Optional tone ('default', 'info', 'warning', 'success', 'danger')
 * @param {string} props.hint - Optional supporting line under the value
 * @param {Object} props.delta - Optional trend, { direction: 'up'|'down'|'flat', label }
 * @param {boolean} props.loading - Show a placeholder instead of the value
 */
const MetricCard = ({
  icon,
  title,
  value,
  tone = "default",
  hint,
  delta,
  loading = false,
}) => {
  return (
    <div className={`metricCard tone-${tone} ${loading ? "isLoading" : ""}`}>
      <div className="cardContent">
        <h3 title={title}>{title}</h3>
        <p className="value">{loading ? "0" : value}</p>
        {delta && (
          <span className={`metricDelta ${delta.direction || "flat"}`}>
            {delta.direction === "up" && "▲"}
            {delta.direction === "down" && "▼"}
            {delta.label}
          </span>
        )}
        {hint && !delta && <span className="metricHint">{hint}</span>}
      </div>
      {icon && <div className="cardIcon">{icon}</div>}
    </div>
  );
};

export default MetricCard;
